import React from 'react';
import { useField } from 'formik';
import PropTypes from 'prop-types';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, Stack, Typography } from '@mui/material';

const JumboPasswordField = (props) => {
  const [field, meta] = useField(props);
  const errorText = meta.error && meta.touched ? meta.error : '';
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[:@$!%*?&]).{8,}$/;

  function checkPasswordStrength(password) {
    return passwordRegex.test(password);
  }

  const isStrong = checkPasswordStrength(props?.value);
  return (
    <>
      {' '}
      <FormControl sx={{ width: '100%' }} variant="outlined">
        <InputLabel htmlFor="outlined-adornment-password">{props?.label}</InputLabel>
        <OutlinedInput
          fullWidth
          {...props}
          {...field}
          helperText={errorText}
          error={!!errorText}
          id="outlined-adornment-password"
          type={showPassword ? 'text' : 'password'}
          endAdornment={
            <InputAdornment position="end">
              <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} edge="end">
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          }
        />
        {errorText && <p style={{ color: '#E73145', margin: '3px 14px 0px', fontSize: '12px' }}>{errorText}</p>}
      </FormControl>
      {props.isStrongCheck && (
        <Stack spacing={1} alignItems="flex-start" direction="row" style={{}}>
          <Typography style={{ color: isStrong ? 'green' : 'red', fontSize: '11px', fontWeight: 'bold' }}>
            {isStrong ? 'Strong' : 'Weak'}
          </Typography>
          <Typography
            style={{
              color: /[A-Z]/.test(props?.value) ? 'green' : 'red',
              fontSize: '11px',
              fontWeight: 'bold',
            }}>
            Uppercase
          </Typography>
          <Typography
            style={{
              color: /[a-z]/.test(props?.value) ? 'green' : 'red',
              fontSize: '11px',
              fontWeight: 'bold',
            }}>
            Lowercase
          </Typography>
          <Typography
            style={{
              color: /\d/.test(props?.value) ? 'green' : 'red',
              fontSize: '11px',
              fontWeight: 'bold',
            }}>
            Number
          </Typography>
          <Typography
            style={{
              color: /[:@$!%*?&]/.test(props?.value) ? 'green' : 'red',
              fontSize: '11px',
              fontWeight: 'bold',
            }}>
            Symbol
          </Typography>
        </Stack>
      )}
    </>
  );
};

JumboPasswordField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
};

export default JumboPasswordField;
